module.exports = __webpack_public_path__ + "static/image/font/pc/bmkiranghaerang-3@3x.ver2_0_2.jpg?2aa547d8";